import React from 'react';
import { ArrowRight, Sparkles } from 'lucide-react';
import Button from '../common/Button';

const HeroSection = ({ 
  title, 
  subtitle, 
  ctaText, 
  ctaLink, 
  backgroundImage,
  children 
}) => {
  return (
    <div className="relative overflow-hidden bg-gradient-to-r from-primary-600 via-primary-700 to-primary-800 text-white">
      {/* Background decoration */}
      {backgroundImage && (
        <div className="absolute inset-0 opacity-20">
          <img
            src={backgroundImage}
            alt=""
            className="w-full h-full object-cover"
          />
        </div>
      )}
      
      {/* Animated background */}
      <div className="absolute inset-0">
        <div className="absolute top-20 right-10 w-72 h-72 bg-primary-500 rounded-full mix-blend-multiply filter blur-3xl opacity-20 animate-pulse"></div>
        <div className="absolute -bottom-8 left-20 w-72 h-72 bg-primary-400 rounded-full mix-blend-multiply filter blur-3xl opacity-20 animate-pulse animation-delay-2000"></div>
      </div>

      {/* Content */}
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 sm:py-32">
        <div className="text-center">
          {/* Badge */}
          <div className="inline-block mb-4 px-4 py-2 bg-primary-500 bg-opacity-50 rounded-full text-sm font-medium backdrop-blur-sm border border-primary-300 border-opacity-50">
            <div className="flex items-center gap-2">
              <Sparkles className="w-4 h-4" />
              منصة تعليمية متقدمة
            </div>
          </div>

          {/* Title */}
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold mb-6 leading-tight">
            {title}
          </h1>

          {/* Subtitle */}
          {subtitle && (
            <p className="text-xl sm:text-2xl text-primary-100 mb-8 max-w-3xl mx-auto leading-relaxed">
              {subtitle}
            </p>
          )}

          {/* Children */}
          {children}

          {/* CTA Button */}
          {ctaText && ctaLink && (
            <div className="mt-8">
              <Button 
                variant="primary" 
                size="lg"
                className="bg-white hover:bg-gray-100 text-primary-700 inline-flex"
              >
                {ctaText}
                <ArrowRight className="w-5 h-5" />
              </Button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default HeroSection;
